<app-barra-crud [state]="state" (salvando)="salvar()" (voltando)="busca()" (inserindo)="novo()" (editando)="editar()"
  (excluindo)="excluir()" (cancelando)="cancelar()" [formValido]="f.valid">
</app-barra-crud>
<div class="conteudo cadastro">
  <form role="form" #f="ngForm" novalidate>
    <nav class="topo-abas">
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a translate id="dados-principais-tab" href="#dados-principais" aria-controls="dados-principais"
          aria-selected="true" class="nav-item nav-link active" data-toggle="tab" role="tab">
          {{'parametros.grupoImportador.cadastro.dadosPrincipais.abaDadosPrincipais'}}
        </a>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div id="dados-principais" aria-labelledby="dados-principais-tab" class="tab-pane fade show active"
        role="tabpanel">
        <header translate class="titulo">{{'parametros.grupoImportador.cadastro.dadosPrincipais.abaDadosPrincipais'}}
        </header>
        <div class="container-fluid">
          <div class="row">
            <div class="form-group col-lg-12">
              <small translate
                class="form-text text-muted">{{'parametros.grupoImportador.cadastro.CampoObrigatorio'}}</small>
            </div>
          </div>
          <div class="row">
            <app-text-box [state]="state" class="col-lg-3"
              label="{{'parametros.grupoImportador.cadastro.dadosPrincipais.idGrupoImportador' | translate}}" name="idGrupoImportador"
              [(ngModel)]="model.id"
              placeholder="{{'parametros.grupoImportador.cadastro.dadosPrincipais.idGrupoImportadorPlaceHolder' | translate}}"
              [ativo]="false"></app-text-box>
          </div>
          <div class="row">
            <app-text-box [state]="state" class="col-lg-6"
              label="{{'parametros.grupoImportador.cadastro.dadosPrincipais.descricao' | translate}}" name="descricao"
              [(ngModel)]="model.descricao" obrigatorio="true" required
              placeholder="{{'parametros.grupoImportador.cadastro.dadosPrincipais.descricaoPlaceHolder' | translate}}"></app-text-box>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>